﻿$.fn.dxCtrlBuilderEmailPage = function custom_dxCtrlBuilderEmailPage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailpage dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailPage(this, option));
    }
    return this;
}

window.idxConstructEmail = 0
window.cdxCtrlBuilderEmailPage = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.mGetJauge = function () { return option.jauge }
    if (typeof option.isFormulaire == 'undefined') option.isFormulaire = false

    this.isDirty = false

    idxConstructEmail += 1
    var idxInterneConstructEmail = idxConstructEmail
    var contentElementLeft = null
    var contentElementRight = null
    function mConstruit() {
        container.empty();
        container.css({
            width: "100%",
            height: "100%",
            position: "relative"
        })

        var ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            context_grid: "buildermail",
            widthLeftInitial: container.innerWidth() - 401,
            minSizeRight: 284,
            collapsibleLeft: false,
            collapsibleRight: false
        }).dxCtrlSplitterResize2("instance")
        ctrlResize.mConstruitLeft(function (contentElementLeftInit) {
            contentElementLeft = contentElementLeftInit
            mConstruitLeft(function () {
                if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)
                resizeObserver.mAdd(container, function () { Me.mUpdateStyle() })
            })
            Me.isDirty = false
        })
        ctrlResize.mConstruitRight(function (contentElementRightInit) {
            contentElementRight = contentElementRightInit
            mConstruitRight()
            Me.isDirty = false
        })

        //contentElementLeft = $("<div style='width:calc(100% - 372px);height:100%;top:0;left:0;position:absolute;;'/>").appendTo(container)
        //contentElementRight = $("<div style='width:372px;height:100%;top:0;left:calc(100% - 372px);position:absolute;'/>").appendTo(container)

        //mConstruitLeft()
        //mConstruitRight()


    }

    var $DivCouvreIframe = null
    var iframePageContainer = null
    var dxScrollViewer = null
    var dxUndoRedo = null
    //function mResize() {
    //    dxScrollViewer.element().find(".dx-scrollview-content").css("min-height", container.innerHeight() + "px")
    //}

    var eleSelected = null
    function mConstruitLeft(funcFin) {
        contentElementLeft.css("position", "relative")
        //contentElementLeft.AddClass("ph-no-capture")
        iframePageContainer = contentElementLeft
        //dxScrollViewer = $("<div/>").appendTo(contentElementLeft).dxCtrlScrollView({
        //    useNative: true,
        //    ScrollDirection: "vertical"
        //}).dxScrollView("instance")
        ////dxScrollViewer.content().addClass("isolated")
        //resizeObserver.mAdd(dxScrollViewer.element(), function () {
        //    mResize()
        //})

        contentElementLeft.on("click.emailhtml" + idxInterneConstructEmail, function (e) {
            $DivBody.find(".selected").removeClass("selected")
            eleSelected = null;
            dxCtrlMenu.mRempliButton()
        })
        //mResize()

        //$('<style id="cssconcepteur">' + cssConcepteur + '</style>').appendTo(iframePageContainer)
        if (typeof option.html != 'undefined' && option.html != null && option.html.length > 0 && option.html.contains("divbodymessage")) {
            var html = option.html.split("<body")[1]
            html = html.substring(html.indexOf(">") + 1).split("</body>")[0]
            mRempliHtml(html, function () { mFin() })
        } else {
            //new
            mInitNewTemplate(function () { mFin() })
            //mConstruireTemplate()
        }

        function mFin() {
            Me.mUpdateStyle()

            // widget sélectionné lors de la sauvegarde
            $WidgetASelectionnerAuChargement = $DivBody.find(".widget.oldselected, .widget.selected").first()
            $DivBody.find(".oldselected").removeClass("oldselected")

            dxUndoRedo = $("<div style='position:absolute;top:2px;right:2px;z-index:10;'/>").appendTo(contentElementLeft).dxCtrlBuilderEmailPageUndoRedo({
                bddCtrl: option.bddCtrl,
                html: bodyIframe.find(".divbodymessage")[0].outerHTML,
                dxBtUndo: option.dxBtUndo,
                dxBtRedo: option.dxBtRedo,
                onChangeAction: function (html) {
                    // on remplace le div entier (html = outerHTML de .divbodymessage)
                    // au lieu de le vider puis de le remplir, ce qui créait un .divbodymessage imbriqué
                    $DivBody.replaceWith(html)

                    // les anciennes références pointent vers des éléments supprimés : on les recalcule
                    $DivBody = $(bodyIframe.find(".divbodymessage")[0])
                    Me.$TablePage = $($DivBody.find(".tablepage")[0])
                    Me.$TableMessage = $($DivBody.find(".tablemessage")[0])
                    $EleStyleLocal = $DivBody.find("#csslocal").first()
                    if ($EleStyleLocal.length == 0) $EleStyleLocal = $('<style type="text/css" id="csslocal"/>').prependTo($DivBody)

                    Me.mUpdateStyle()
                    mInitDrags()
                    mRemoveClick()

                    $DivBody.find(".selected").removeClass("selected")
                    widgetElementSelected = null
                    dxCtrlMenu.mRempliButton()

                    mWidgetsChanged("undoredo", null)
                }
                //onChangeAction: function (html) {
                //    bodyIframe.find(".divbodymessage").empty()
                //    bodyIframe.find(".divbodymessage").html(html)
                //    //mRempliHtml(html)
                //    Me.mUpdateStyle()
                //    mInitDrags()
                //    mRemoveClick()

                //    $DivBody.find(".selected").removeClass("selected")
                //    eleSelected = null;
                //    dxCtrlMenu.mRempliButton()

                //    mWidgetsChanged("undoredo", null)
                //}
            }).dxCtrlBuilderEmailPageUndoRedo("instance")

            mWidgetsChanged("undoredo", null)   // active l'anti-doublon undo dès le chargement
            Me.isDirty = false

            mInitDrags()
            mRemoveClick()

            isIframePret = true
            mSelectionInitiale()

            funcFin()
        }

    }

    var $Iframe = null
    var bodyIframe = null
    var $DivBody = null
    var $EleStyleLocal = null
    this.$TablePage = null
    this.$TableMessage = null
    var iframeContainer = null
    function mInitNewTemplate(funcFin) {
        $DivCouvreIframe = $("<div style='height:100%;width:100%;position:absolute;z-index:99999;display:none;'/>").appendTo(iframePageContainer)
        $Iframe = $("<iframe src='about:blank' style='width:100%;height:100%;border:none;overflow-x:auto;overflow-y:auto;white-space:nowrap;'/>").on("load", function () {
            var iframeDoc = $Iframe[0].contentDocument || $Iframe[0].contentWindow.document;
            iframeDoc.open();
            iframeDoc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//FR">' +
                '<html lang="fr" style="">' +
                '<head>' +
                '<meta http-equiv="Content-Type" content="text/html; charset=utf-8">' +
                '<meta name="viewport" content="width=device-width, initial-scale=1.0">' +
                '<title></title>' +
                '</head>' +
                '<body>' +
                '</body>' +
                '</html>');
            iframeDoc.close();

            bodyIframe = $(iframeDoc.body)
            bodyIframe.css({
                "position": "relative",
                "padding": "0",
                "margin": "0",
                "overflow-x": "auto",
                "overflow-y": "auto",
                //"white-space":"nowrap"
            })

            $DivBody = $('<div style="-moz-text-size-adjust:none!important;padding:0px!important;-webkit-text-size-adjust:none!important;margin:0px!important;-ms-text-size-adjust:none!important;white-space:wrap;" class="divbodymessage" titre="" nom=""/>').appendTo($(bodyIframe))
            $('<style id="cssconcepteur">' + cssConcepteur + '</style>').appendTo($DivBody)
            //$("<!--[if (gte mso 9)|(IE)]>commentaire<![endif]-->").appendTo($DivBody)
            Me.$TablePage = $('<table class="tablepage" width="100%" border="0" cellspacing="0" cellpadding="0" align="center" titre="" nom=""/>').appendTo($DivBody)
            Me.$TablePage.attr("jsonCssGuide", JSON.stringify(Me.jsonCssGuideBase))
            $('<style id="style_a">' + mGetCssA() + '</style>').appendTo($DivBody)
            var $Tr = $('<tr/>').appendTo(Me.$TablePage[0])
            var $Td = $('<td valign="top" class="tdpage">').appendTo($Tr)
            $("<!--[if (gte mso 9)|(IE)]><center style='width:100%;table-layout:fixed;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;'><![endif]-->").appendTo($Td)
            $("<!--[if (gte mso 9)|(IE)]><table width='600' align='center' style='border-spacing:0;' class='tablemessagemso'><tr><td style='padding:0;'><![endif]-->").appendTo($Td)
            Me.$TableMessage = $('<table class="acceptwidget tablemessage" align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="width:100%;max-width:600px;"><tr/></table>').appendTo($Td)
            $("<!--[if (gte mso 9)|(IE)]></td></tr></table><![endif]-->").appendTo($Td)
            $("<!--[if (gte mso 9)|(IE)]></center><![endif]-->").appendTo($Td)
            var $EleStyleBase = $('<style  type="text/css" id="cssbaseV1">' + cssBaseV1 + '</style>').prependTo($DivBody)
            $EleStyleLocal = $('<style  type="text/css" id="csslocal">' + Me.mGetCssLocal() + '</style>').prependTo($DivBody)

            $DivBody.closest("html").css("background-color", Me.mJsonCssGuideProperty("bodypage", "background-color"))



            $(this.contentWindow.document).on("mousedown", function () {
                const active = document.activeElement;
                if (active && active !== document.body) {
                    active.blur();
                }
            });

            if (option.isFormulaire) {
                Me.clBuilderFormulaire = new cBuilderFormulaire(option.bddCtrl, $Iframe)
                Me.clBuilderFormulaire.mInitIframe(funcFin)
            } else {
                funcFin()
            }

        })
        $Iframe.appendTo(iframePageContainer)

    }

    function mWidgetsChanged(typeAction, $Ele) {
        // typeAction : "ajout" | "deplacement" | "suppression" | "duplication" | "undoredo"
        Me.isDirty = true
        $DivBody.find(".eledevexpress").each(function (index, element) {
            $(element).attr("tri", index)
        })
        if (dxUndoRedo) {
            // html sans les marques propres à l'éditeur (sélection, drag...) : seuls les vrais changements comptent
            var mGetHtmlUndo = function () {
                var $Clone = $DivBody.clone()
                $Clone.find(".ui-draggable-dragging").remove()
                $Clone.find("*").addBack().removeClass("selected oldselected ui-draggable ui-draggable-handle ui-draggable-dragging texture_drag_construct_email")
                $Clone.find("[class='']").removeAttr("class")
                $Clone.find("[style='']").removeAttr("style")
                return $Clone[0].outerHTML
            }

            // une seule fois : on intercepte mAddAction pour TOUS les appelants
            if (!dxUndoRedo.mAddActionOrigine) {
                dxUndoRedo.mAddActionOrigine = dxUndoRedo.mAddAction
                dxUndoRedo.mAddAction = function () {
                    // les appels rapprochés (< 300 ms) sont regroupés en un seul undo
                    clearTimeout(dxUndoRedo.timerUndo)
                    dxUndoRedo.timerUndo = setTimeout(function () {
                        dxUndoRedo.timerUndo = null
                        var htmlUndo = mGetHtmlUndo()
                        if (htmlUndo == dxUndoRedo.lastHtmlUndo) return
                        dxUndoRedo.lastHtmlUndo = htmlUndo
                        dxUndoRedo.mAddActionOrigine.call(dxUndoRedo, htmlUndo)
                    }, 300)
                }
            }

            if (typeAction == "undoredo") {
                // un undo/redo annule toute photo en attente, et on recale la référence sur l'état restauré
                clearTimeout(dxUndoRedo.timerUndo)
                dxUndoRedo.timerUndo = null
                dxUndoRedo.lastHtmlUndo = mGetHtmlUndo()
            } else {
                dxUndoRedo.mAddAction()
            }
        }


        if (typeof option.onWidgetsChanged != 'undefined') option.onWidgetsChanged(typeAction, $Ele)
    }

    this.clBuilderFormulaire = null
    function mRempliHtml(optHtml, funcFin) {
        iframePageContainer.empty()

        $DivCouvreIframe = $("<div style='height:100%;width:100%;position:absolute;z-index:99999;display:none;'/>").appendTo(iframePageContainer)
        $Iframe = $("<iframe src='about:blank' style='width:100%;height:100%;border:none;overflow-x:hidden;overflow-y:hidden;white-space:nowrap;'/>").on("load",
            function () {
                var iframeDoc = $Iframe[0].contentDocument || $Iframe[0].contentWindow.document;
                iframeDoc.open();
                iframeDoc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//FR">' +
                    '<html lang="fr" style="">' +
                    '<head>' +
                    '<meta http-equiv="Content-Type" content="text/html; charset=utf-8">' +
                    '<meta name="viewport" content="width=device-width, initial-scale=1.0">' +
                    '<title></title>' +
                    '</head>' +
                    '<body>' +
                    '</body>' +
                    '</html>');
                iframeDoc.close();

                //$(iframeDoc).on("dragover", function (event) {
                //    event.preventDefault();
                //});

                bodyIframe = $(iframeDoc.body)
                bodyIframe.css({
                    "position": "relative",
                    "padding": "0",
                    "margin": "0",
                    "overflow-x": "hidden"
                })

                $(optHtml).appendTo(bodyIframe)
                //on restaure le style d'origine des éléments modifiés à l'export (styles inline ajoutés par mGetHtml : liens, ancienne option masquage)
                bodyIframe.find("[data-styleorigine]").each(function () {
                    var styleOrigine = $(this).attr("data-styleorigine")
                    if (styleOrigine.length > 0) { $(this).attr("style", styleOrigine) } else { $(this).removeAttr("style") }
                    $(this).removeAttr("data-styleorigine")
                })
                bodyIframe.find(".masquemobile, .masquelarge").removeClass("masquemobile masquelarge")
                bodyIframe.find("*").contents().filter(function () {
                    return this.nodeType == 8 && (this.nodeValue == "[if !mso]><!" || this.nodeValue == "<![endif]")
                }).remove()
                $DivBody = $(bodyIframe.find(".divbodymessage")[0])
                //mGetHtml met cssbaseV1 et csslocal dans le <head>, qui n'est pas rechargé : on les recrée s'ils sont absents
                if ($DivBody.find("#cssbaseV1").length == 0) $('<style type="text/css" id="cssbaseV1"/>').prependTo($DivBody)
                if ($DivBody.find("#csslocal").length == 0) $('<style type="text/css" id="csslocal"/>').prependTo($DivBody)
                $('<style id="cssconcepteur">' + cssConcepteur + '</style>').appendTo($DivBody)
                var $EleStyleBaseV1 = $(bodyIframe.find("#cssbaseV1")[0])
                $EleStyleLocal = $(bodyIframe.find("#csslocal")[0])
                Me.$TablePage = $(bodyIframe.find(".tablepage")[0])
                $DivBody.find("#style_a").remove()
                $('<style id="style_a">' + mGetCssA() + '</style>').appendTo($DivBody)
                mVerifyJsonCssGuide()
                Me.$TableMessage = $(bodyIframe.find(".tablemessage")[0])
                $EleStyleBaseV1.text(cssBaseV1)
                $EleStyleLocal.text(Me.mGetCssLocal())
                bodyIframe.find(".dxwidgetimage").find("a:not([href]), a[href=''], a[href='https://'], a[href='http://']").each(function () {
                    $(this).css("pointer-events", "none")
                })

                if (Me.$TableMessage.children('tr:not([class])').add(Me.$TableMessage.find('> tbody').children('tr:not([class])')).length == 0 && Me.$TableMessage.children('tr').add(Me.$TableMessage.find('> tbody').children('tr')).length > 0) {
                    //on a un template créer avant le passage avec une iframe et qui a déjà des tr
                    //on rajoute un tr vide
                    $("<tr/>").appendTo(Me.$TableMessage)
                }

                $DivBody.closest("html").css("background-color", Me.mJsonCssGuideProperty("bodypage", "background-color"))

                $(iframeDoc).on("click.emailhtmlbody" + idxInterneConstructEmail, function (e) {
                    $DivBody.find(".selected").removeClass("selected")
                    eleSelected = null;
                    dxCtrlMenu.mRempliButton()
                })

                $(this.contentWindow.document).on("mousedown", function () {
                    const active = document.activeElement;
                    if (active && active !== document.body) {
                        active.blur();
                    }
                });

                if (option.isFormulaire) {
                    Me.clBuilderFormulaire = new cBuilderFormulaire(option.bddCtrl, $Iframe)
                    Me.clBuilderFormulaire.mInitIframe(funcFin)
                } else {
                    funcFin()
                }

            })


        $Iframe.appendTo(iframePageContainer)
    }

    this.mGetIdComEmailEnvoiOuIdFichier = function () {
        return option.onDemandeIdComEmailEnvoi()
    }
    this.mDeclencheSaveAuto = function (funcFin) {
        if (typeof option.onDeclencheSaveAuto == 'undefined') {
            funcFin()
        } else (option.onDeclencheSaveAuto(funcFin))
    }

    this.getCurrentEditorHtml = function () {
        if (widgetElementSelected == null) { return null }
        else { return widgetElementSelected.getCurrentEditorHtml() }
    }

    function mRemoveClick() {
        $DivBody.find("a").each(function (idx, ele) {
            $(ele).off("click")
            //$(ele).on("click", function (e) { $($(e.target).parent()).trigger("click", e); return false })
            $(ele).on("click", function (e) { $(this).closest(".widget").trigger("click"); return false })
        })
    }
    var dxCtrlMenu = null
    function mConstruitRight() {
        contentElementRight.css({
            "position": "relative",
            "border-left": theme.border
        })
        dxCtrlMenu = $("<div style='position:absolute;width:100%;height:100%;'/>").appendTo(contentElementRight).dxCtrlBuilderEmailPageMenu({
            bddCtrl: option.bddCtrl,
            dxBuilderEmailPage: Me,
            jauge: option.jauge,
            lstfileheberge: option.lstfileheberge,
            isFormulaire: option.isFormulaire,
            onValueChanged: function () {
                Me.isDirty = true
                Me.mUpdateStyle()
                if (dxUndoRedo) dxUndoRedo.mAddAction(bodyIframe.find(".divbodymessage")[0].outerHTML)
            },
            onSelectButton: function () {
                widgetElementSelected = null;
                $DivBody.find(".selected").removeClass("selected")
            },
            onSelectMiseEnPage: function () {
                widgetElementSelected = null;
                $DivBody.find(".selected").removeClass("selected")
            },
            onBackOnWidget: function (e) {
                widgetElementSelected = null;
                $DivBody.find(".selected").removeClass("selected")
            },
            onDeleteWidget: function () {
                var oldSelected = widgetElementSelected
                oldSelected.slideUp(300, function () {
                    oldSelected.remove()
                    Me.mUpdateStyle()
                    mWidgetsChanged("suppression", oldSelected)
                })
                widgetElementSelected = null;
                Me.mUpdateStyle()
                Me.isDirty = true
            },
            onDuplikWidget: function (e) {
                var clone = widgetElementSelected.clone()
                if (clone.find(".eledevexpress").length > 0) {
                    $(clone.find(".eledevexpress")).attr("indexdevexpress", Me.clBuilderFormulaire.mGetNewIndexDevexpress())
                }
                clone.insertAfter(widgetElementSelected)
                if (clone.find(".eledevexpress").length > 0) {
                    $(clone.find(".eledevexpress")).empty()
                    Me.clBuilderFormulaire.mAddCtrlDevExpress(clone)
                }
                widgetElementSelected = clone;
                $DivBody.find(".selected").removeClass("selected")
                widgetElementSelected.addClass("selected")
                Me.mUpdateStyle()
                dxCtrlMenu.mRempliWidget(widgetElementSelected)
                mInitDrags()
                widgetElementSelected.addClass("selected")
                mWidgetsChanged("duplication", clone)
            },
            onDemandeVisuHideAcid: option.onDemandeVisuHideTestAcid
        }).dxCtrlBuilderEmailPageMenu("instance")
        mSelectionInitiale()
    }

    this.mSelectWidget = function ($EleWidget) {
        $EleWidget.trigger("click")
    }

    var $WidgetASelectionnerAuChargement = null
    var isIframePret = false
    function mSelectionInitiale() {
        // on attend que l'iframe ET le menu de droite soient prêts
        if (!isIframePret || dxCtrlMenu == null) return
        if ($WidgetASelectionnerAuChargement == null || $WidgetASelectionnerAuChargement.length == 0) return

        var $Ele = $WidgetASelectionnerAuChargement
        $WidgetASelectionnerAuChargement = null
        // le click handler sort si l'élément a déjà "selected"
        $Ele.removeClass("selected oldselected")
        Me.mSelectWidget($Ele)
    }

    function mInitDrags() {
        $DivBody.find(".selected").removeClass("selected")
        $DivBody.find(".widget").each(function (idx, ele) {
            if (!$(ele).hasClass("dxwidgetvide")) Me.mInitDrag($(ele), "original")
        })
    }
    var widgetElementSelected = null
    this.mInitDrag = function (ele, helper) {
        //ele.isClone = (helper == "original")
        if (helper == "original") {
            ele.off("click")
            ele.on("click", function (e) {
                e.stopPropagation()
                if ($(this).hasClass("selected")) return
                if ($(this).hasClass("selected")) return
                $DivBody.find(".selected").removeClass("selected")
                $DivBody.find(".oldselected").removeClass("oldselected")
                $(this).addClass("selected")
                widgetElementSelected = ele
                dxCtrlMenu.mRempliWidget(widgetElementSelected)
                //mConstruitRight()
            })
        }

        var mouseScreen = null
        ele.draggable({
            helper: "clone",
            cursor: "move",
            appendTo: ((helper == "original") ? $Iframe[0].contentWindow.document.documentElement : container), //contentElementLeft,
            start: function (event, ui) {
                $(document).on('mousemove.builderemail', function (event) {
                    mouseScreen = { x: event.clientX, y: event.clientY }
                    //console.log("mousemoveparent " + mouseScreen)
                });
                var iframeDoc = $Iframe[0].contentDocument || $Iframe[0].contentWindow.document;
                $(iframeDoc).on("mousemove.builderemail", function (event) {
                    if (rectIframe == null) rectIframe = $Iframe[0].getBoundingClientRect();
                    mouseScreen = { x: event.clientX + rectIframe.left, y: event.clientY + rectIframe.top }
                    console.log(mouseScreen)
                    //console.log("Coordonnées de la souris dans l'iframe (écran) :", event.screenX, event.screenY);
                });
                bodyIframe.find(".bodywidget").css("border", "1px dashed gray")
                dxCtrlMenu.mGetDxScroll().option("disabled", true)
                $DivCouvreIframe.show()
                if (helper == "original") {
                    //$DivCouvreIframe.css("background-color", "rgba(0,0,0,0.5)")
                    //$DivCouvreIframe.show()
                    ele.css("opacity", 0.5)
                    ui.helper.css({
                        "width": ele.closest(".widget").innerWidth() + "px",
                        opacity: 1
                    })
                    ui.helper.find("td:first").css({
                        "width": ele.closest(".widget").innerWidth() + "px",
                    })
                    ui.helper.css({
                        "transform": "scale(0.5)",
                        top: -(ele.closest(".widget").innerWidth() / 2) + "px",
                        left: -(ele.closest(".widget").innerWidth() / 2) + "px"
                    })
                    //ui.helper.addClass("texture_drag_construct_email")
                    console.log(ui.helper[0])
                } else {
                    //$DivCouvreIframe.css("background-color", "rgba(0,0,0,0.5)")
                    //window.setTimeout(function () {
                    //    $Iframe.focus()
                    //    $Iframe[0].contentWindow.focus();
                    //}, 0)
                    ui.helper.css({ "z-index": 100000000 })
                }
            },
            drag: function (event, ui) {
                //$Iframe.focus()
                //$Iframe[0].contentWindow.focus();
                var coord = { x: event.pageX, y: event.pageY }

                //isInIframe = mIsInIframe(coord)
                //if (isInIframe) {
                //    $DivCouvreIframe.css("background-color", "rgba(128,128,0,0.2)")
                //} else {
                //    $DivCouvreIframe.css("background-color", "rgba(0,0,0,0.5)")
                //}

                //var eleScroll = $Iframe[0].contentWindow.document.documentElement
                if (helper != "original") {
                    //ajout d'un élément à partir du parent
                    var coordIframe = JSON.parse(JSON.stringify(coord))
                    mTransformeCoordFromParent(coordIframe, false)
                    var posTop = coordIframe.y - $DivBody.offset().top
                    mRemoveLigneInsert()
                    $DivBody.find(".dxcoltddrag").removeClass("dxcoltddrag")
                    $DivBody.find(".dxcoltabledrag").removeClass("dxcoltabledrag")
                    var eleRef = mGetElementHovered(coordIframe.x, coordIframe.y, ui, ele, false)
                    bodyIframe.find(".widget").removeClass("texture_drag_construct_email")
                    bodyIframe.find(".acceptwidget").removeClass("texture_drag_construct_email")
                    if (eleRef != null) {
                        eleRef.addClass("texture_drag_construct_email")
                        var topY = eleRef.offset().top
                        var Left = eleRef.offset().left

                        if (eleRef.hasClass("widget")) {
                            mShowSeparator(topY + eleRef.innerHeight(), Left, $(eleRef.closest(".acceptwidget")[0]))
                        } else {
                            mShowSeparator(topY, Left, eleRef)
                        }
                    } else {
                        //aucun element
                    }
                    mVerifScroll()
                } else {
                    //Déplacement dans l'iframe
                    //var scrollTop = eleScroll.scrollTop;
                    //console.log("scrolltop: " + scrollTop)

                    var coordIframe = JSON.parse(JSON.stringify(coord))
                    var posTop = coordIframe.y - $DivBody.offset().top
                    mRemoveLigneInsert()
                    $DivBody.find(".dxcoltddrag").removeClass("dxcoltddrag")
                    $DivBody.find(".dxcoltabledrag").removeClass("dxcoltabledrag")
                    var eleRef = mGetElementHovered(coordIframe.x, coordIframe.y, ui, ele, true)
                    bodyIframe.find(".widget").removeClass("texture_drag_construct_email")
                    bodyIframe.find(".acceptwidget").removeClass("texture_drag_construct_email")
                    if (eleRef != null) {
                        eleRef.addClass("texture_drag_construct_email")
                        var topY = eleRef.offset().top
                        var Left = eleRef.offset().left

                        if (eleRef.hasClass("widget")) {
                            mShowSeparator(topY + eleRef.innerHeight(), Left, $(eleRef.closest(".acceptwidget")[0]))
                        } else {
                            mShowSeparator(topY, Left, eleRef)
                        }
                    } else {
                        //aucun element
                    }
                    mVerifScroll()
                }
            },
            stop: function (event, ui) {
                $(document).off('mousemove.builderemail');
                var iframeDoc = $Iframe[0].contentDocument || $Iframe[0].contentWindow.document;
                $(iframeDoc).off("mousemove.builderemail")
                mouseScreen = null
                $DivCouvreIframe.hide()
                bodyIframe.find(".widget").removeClass("texture_drag_construct_email")
                bodyIframe.find(".acceptwidget").removeClass("texture_drag_construct_email")
                var coord = { x: event.pageX, y: event.pageY }
                mRemoveLigneInsert()

                var eleRef = null
                if (helper != "original") {
                    //ajout d'un élément à partir du parent
                    var coordIframe = JSON.parse(JSON.stringify(coord))
                    mTransformeCoordFromParent(coordIframe, false)
                    eleRef = mGetElementHovered(coordIframe.x, coordIframe.y, ui, ele, false)
                } else {
                    var coordIframe = JSON.parse(JSON.stringify(coord))
                    eleRef = mGetElementHovered(coordIframe.x, coordIframe.y, ui, ele, true)
                }

                if (helper == "original") {
                    ele.css("opacity", 1)
                    //ele.css("width", "100%")
                }
                $DivBody.find(".dxcoltddrag").removeClass("dxcoltddrag")
                $DivBody.find(".dxcoltabledrag").removeClass("dxcoltabledrag")
                dxCtrlMenu.mGetDxScroll().option("disabled", false)
                var eleMove = null
                if (eleRef != null) {
                    if (helper == "original") {
                        //on déplace un element qui est déjà présent
                        eleMove = ele
                    } else {
                        //glisser un nouvel element à partir d'un bouton
                        eleMove = (new cBuilderEmailWidget({
                            bddCtrl: option.bddCtrl,
                            dxBuilderEmailPage: Me,
                            typeWidget: ui.helper.attr("typewidget"),
                            nbCol: ui.helper.attr("nbcol"),
                            tag: ui.helper.attr("tag"),
                            tag2: ui.helper.attr("tag2")
                        })).option("element")
                    }
                    if (eleRef.hasClass("widget")) { eleRef.after(eleMove[0]) }
                    else { eleRef.prepend(eleMove[0]) }
                    if (helper != "original") {
                        switch (ui.helper.attr("typewidget")) {
                            case "dxwidgetsignature":
                                //on demande de sélectionné la signature
                                var lstDataCpteEmailUtiWithSignature = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmailUtilisateur().filter(function (dataCptEmailUti) {
                                    return typeof dataCptEmailUti.data_signature != "undefined" && dataCptEmailUti.data_signature != null && dataCptEmailUti.data_signature.length > 0
                                })
                                if (lstDataCpteEmailUtiWithSignature.length > 0 || (typeof option.bddCtrl.utiCourant.data_signature != "undefined" && option.bddCtrl.utiCourant.data_signature != null && option.bddCtrl.utiCourant.data_signature.length > 0)) {
                                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                        target: eleMove,
                                        shading: true,
                                        contentTemplate: function (contentElement) {
                                            contentElement.css("padding", "25px")
                                            contentElement.css("text-align", "left")
                                            $("<div style='font-size:140%;padding:10px 5px;' class='dx-theme-accent-as-text-color'>Sélectionner la signature à intégrer</div>").appendTo(contentElement)
                                            var $Table = $("<table/>").appendTo(contentElement)
                                            lstDataCpteEmailUtiWithSignature.forEach(function (dataCpteEmailUti) {
                                                var dataCpteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) {
                                                    return o.id_compte_email == dataCpteEmailUti.id_compte_email
                                                })[0]
                                                var $Tr = $("<tr/>").appendTo($Table)
                                                var $Td = $("<td class='state-hover' style='padding:10px 5px;'>Signature de l'adresse <u>" + dataCpteEmail.adresse_email + "</u></td>").appendTo($Tr)
                                                $Td.on("click", function () { mInitWithSignature(dataCpteEmailUti.data_signature) })
                                            })
                                            if (typeof option.bddCtrl.utiCourant.data_signature != "undefined" && option.bddCtrl.utiCourant.data_signature != null) {
                                                var $Tr = $("<tr/>").appendTo($Table)
                                                var $Td = $("<td class='state-hover' style='padding:10px 5px;'>Votre signature utilisateur</td>").appendTo($Tr)
                                                $Td.on("click", function () { mInitWithSignature(option.bddCtrl.utiCourant.data_signature) })
                                            }

                                            function mInitWithSignature(dataSignature) {
                                                option.bddCtrl.mAjaxCall({
                                                    command: "gethtmlbodyfromsignature",
                                                    data_signature: dataSignature
                                                }, function (data) {
                                                    eleMove.find(".contenuwidget").html(data.html_body)
                                                    dxCtrlMenu.mRempliWidget(widgetElementSelected)
                                                    tt.hide()
                                                    mWidgetsChanged("ajout", eleMove)
                                                })
                                            }
                                        }
                                    }).dxCtrlTooltip("instance")
                                    tt.show()
                                } else {
                                    mNotify("Vous n'avez aucune signature définie sur vos emails", "warning", 6000)
                                }
                                break;
                            case "dxwidgetperso":
                                option.jauge.mShow();
                                var lstFileHeberge = []
                                option.lstfileheberge.forEach(function (url) {
                                    lstFileHeberge.push({
                                        url: url
                                    })
                                })
                                option.bddCtrl.mAjaxCall({
                                    command: "loadwidgetemail",
                                    id_widget_email: eleMove.find("tr").attr("id_widget_email"),
                                    lst_file_heberge: lstFileHeberge
                                }, function (data) {
                                    if (typeof data.url_file_heberge == "undefined") data.url_file_heberge = []
                                    data.url_file_heberge.forEach(function (url) {
                                        option.lstfileheberge.push(url)
                                    })
                                    if (typeof data.lstimg == "undefined") data.lstimg = []
                                    data.lstimg.forEach(function (urls) {
                                        eleMove.find("img").each(function () {
                                            if ($(this).attr("src") == urls.oldurl) $(this).attr("src", urls.newurl)
                                        })
                                    })
                                    Me.mUpdateStyle()
                                    option.jauge.mHide();
                                    mWidgetsChanged("ajout", eleMove)
                                })
                                break;
                        }
                    }
                }
                Me.mUpdateStyle()
                bodyIframe.find(".bodywidget").css("border", "")
                mInitDrags()
                if (eleMove) {
                    widgetElementSelected = eleMove
                    widgetElementSelected.addClass("selected")
                    dxCtrlMenu.mRempliWidget(widgetElementSelected)
                    if (ui.helper.attr("typewidget") == "dxwidgetperso") {
                        //on resélectionne les widget perso pour qu'il soit bien construit dans le constructeur de droite
                        $DivBody.find(".selected").removeClass("selected")
                        eleSelected = null; Me.mSelectWidget(eleMove)
                    }
                }
                mRemoveClick()

                if (eleMove) mWidgetsChanged(helper == "original" ? "deplacement" : "ajout", eleMove)
                rectIframe = null
            }
        })


        var isScrolling = false
        var deltaScroll = 60
        function mVerifScroll() {
            //console.log("scroll: moussescreen" + mouseScreen)
            if (mouseScreen == null) return
            if ($Iframe[0].contentWindow == null) return
            var iframeDoc = $Iframe[0].contentDocument || $Iframe[0].contentWindow.document;
            $(iframeDoc).scrollLeft(0);

            var eleScroll = $Iframe[0].contentWindow.document.documentElement
            var scrollTop = eleScroll.scrollTop;
            var rectIframe = $Iframe[0].getBoundingClientRect();
            var x = mouseScreen.x - rectIframe.left
            var y = mouseScreen.y - rectIframe.top
            console.log("scroll: " + x + "/" + y + "/" + $Iframe.innerHeight())
            var isOnTop = (y - deltaScroll < 0)
            var isOnBottom = (y + deltaScroll > $Iframe.innerHeight())
            if (!isScrolling && (isOnBottom || isOnTop)) {
                //console.log("scroll - " + y)
                isScrolling = true;
                var scrollAmount = ((isOnTop) ? deltaScroll - y : deltaScroll - ($Iframe.innerHeight() - y))
                eleScroll.scrollTo(0, scrollTop + ((isOnBottom) ? scrollAmount : - scrollAmount));
                setTimeout(() => {
                    isScrolling = false;
                    if (mouseScreen == null) return
                    var x = mouseScreen.x - rectIframe.left
                    var y = mouseScreen.y - rectIframe.top
                    var isOnTop = (y - deltaScroll < 0)
                    var isOnBottom = (y + deltaScroll > $Iframe.innerHeight())
                    if (isOnBottom || isOnTop) {
                        mVerifScroll(); // Relancer le scroll si la souris est toujours en bas
                    }
                }, 100); // Attendre un moment avant de vérifier à nouveau
            }
        }
    }

    var rectIframe = null
    function mTransformeCoordFromParent(coord) {
        // Vérifier si on est dans l'iframe
        if (rectIframe == null) rectIframe = $Iframe[0].getBoundingClientRect();
        //if (coord.x >= rectIframe.left && coord.x <= rectIframe.right && coord.y >= rectIframe.top && coord.y <= rectIframe.bottom) {
        // Envoyer la position à l'iframe
        coord.x -= rectIframe.left
        var y = coord.y - rectIframe.top //+ $Iframe[0].contentWindow.document.body.scrollTop
        //console.log(coord.y + "-=" + rectIframe.top + "+" + $Iframe[0].contentWindow.document.body.scrollTop + "/ " + y)
        coord.y = y
        //console.log("mtransfiormCoordIframe")
        //if ($Iframe[0].contentWindow.document.body.scrollTop>0)     console.log("scrolltop " + $Iframe[0].contentWindow.document.body.scrollTop)
        //}
    }

    function mIsInIframe(coordPage) {
        if (rectIframe == null) rectIframe = $Iframe[0].getBoundingClientRect();
        return (coordPage.x >= rectIframe.left && coordPage.x <= rectIframe.right && coordPage.y >= rectIframe.top && coordPage.y <= rectIframe.bottom)
    }

    function mRemoveLigneInsert() {
        if ($DivDiviser) {
            $DivDiviser.remove()
        }
    }

    this.mTitre = function (value) {
        if (typeof value != 'undefined') {
            Me.$TablePage.attr("titre", value);
            Me.isDirty = true
        }
        return Me.$TablePage.attr("titre")
    }
    this.mNom = function (value) {
        if (typeof value != 'undefined') Me.$TablePage.attr("nom", value)
        return Me.$TablePage.attr("nom")
    }

    var $DivDiviser = null
    function mShowSeparator(topY, Left, containerRef) {
        mRemoveLigneInsert()
        //$DivBody.find(".dxcoltddrag").removeClass("dxcoltddrag")
        //$DivBody.find(".dxcoltabledrag").removeClass("dxcoltabledrag")
        //var padLeftRight = 0
        //var padLeftRightDiv2 = 0
        //if (containerRef.hasClass("tablemessage")) {
        //    //on tient compte des marges du message
        //    padLeftRight = parseInt(Me.$TableMessage.css("padding-left").replace("px", "")) + parseInt(Me.$TableMessage.css("padding-left").replace("px", ""))
        //    padLeftRightDiv2 = padLeftRight / 2
        //}
        //if (containerRef.hasClass("dxcoltd")) {
        //    containerRef.addClass("dxcoltddrag")
        //    containerRef.closest("table").addClass("dxcoltabledrag")
        //}

        var width = containerRef.innerWidth()
        var padTop = 0; //parseInt(Me.$TablePage.css("padding-top").replace("px", "")) + parseInt(Me.$TableMessage.css("padding-top").replace("px", "")) + parseInt(Me.$TableMessage.css("border-width").replace("px", ""))
        $DivDiviser = $("<div style='left:" + Left + "px;width:" + (width - 10) + "px;height:8px;position:absolute;top:" + (topY - 3 + padTop) + "px;z-index:1000000000000;padding:0 5px;' class='dxligneinsert'/>").appendTo(bodyIframe)
        var $Div = $("<div style='width:100%;position:relative;'/>").appendTo($DivDiviser)
        //var $Table = $("<table style='width:100%'/>").appendTo($DivDiviser)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='width:0px;'/>").appendTo($Tr)
        $("<div style='width:16px;height:16px;background-color:" + theme.backgroundcolorAccent + ";z-index:10;border-radius:50%;border:2px solid gray;position:absolute;left:0px;'/>").appendTo($DivDiviser)
        //var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var $Div2 = $("<div style='background-color:" + theme.backgroundcolorAccent + ";border:2px solid gray;width:calc(100% - 10px);height:6px;position:absolute;top:5px;z-index:0;'/>").appendTo($DivDiviser)
        //var $Td = $("<td style='width:0px;'/>").appendTo($Tr)
        $("<div style='width:16px;height:16px;background-color:" + theme.backgroundcolorAccent + ";z-index:10;border-radius:50%;border:2px solid gray;position:absolute;right:0px;'/>").appendTo($DivDiviser)
        //containerRef.css("position", "relative")
    }

    function mGetElementHovered(xIframe, yIframe, ui, ele, isFromIframe) {
        //const rect = $Iframe[0].getBoundingClientRect();
        //pageX = pageX - rect.left;
        //pageY = pageY - rect.top;

        var yIframeScroll = yIframe + $Iframe[0].contentWindow.document.documentElement.scrollTop
        var elementsUnderCursor = []
        if (isFromIframe) {
            yIframeScroll = yIframe
            elementsUnderCursor = ($Iframe[0].contentDocument || $Iframe[0].contentWindow.document).elementsFromPoint(xIframe, yIframe - $Iframe[0].contentWindow.document.documentElement.scrollTop);
        } else {
            elementsUnderCursor = ($Iframe[0].contentDocument || $Iframe[0].contentWindow.document).elementsFromPoint(xIframe, yIframe);
        }
        var lstEle = []
        $(elementsUnderCursor).each(function () {
            lstEle.push($(this))  // rajoute les éléments dans la liste
        });
        console.log(lstEle)
        //var lstEle = mGetElementFromPoint(xIframe, yIframe, $Iframe[0].contentDocument || $Iframe[0].contentWindow.document)
        var nb1 = lstEle.length
        lstEle = lstEle.filter(function (o) { return !o.hasClass("dxligneinsert") && o.closest(".tablepage").length == 1 })
        var nb2 = lstEle.length
        //le mGetElementFromPoint ne renvoi pas les TR
        //on a les TD du dessous
        lstEle.forEach(function (ele, idx) { if (ele.hasClass("tdwidget")) lstEle[idx] = $(ele.parent()) })
        lstEle = lstEle.filter(function (o) { return o.closest(ui.helper).length == 0 && !o.is(ui.helper) && !o.hasClass("ui-draggable-dragging") })
        var nb3 = lstEle.length
        //if (nb3 > 0) debugger;

        var lstContainer = lstEle.filter(function (o) { return o.hasClass("acceptwidget") && o.closest(ui.helper).length == 0 })
        console.log(lstContainer)

        console.log(nb1 + "/" + nb2 + "/" + nb3 + "/" + lstContainer.length)

        var elTableMessage = $($Iframe[0].contentWindow.document).find(".tablemessage");
        if (nb1 > 0 && lstContainer.length == 0) lstContainer.push(elTableMessage)
        ////console.log(lstContainer)
        //////console.log(lstContainer.length)
        //////if (lstContainer.length > 1) console.log(ui.helper[0])
        //if (lstContainer.length >= 2) debugger;
        if (lstContainer.length == 0) {
            //on est sur aucun container
            console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - aucun container " + nb1 + "/" + nb2 + "/" + nb3)
            return null
        } else {
            var eleContainer = lstContainer[0]
            if ((ui.helper.hasClass("dxwidgetcolonne") || ui.helper.find(".acceptwidget").length > 0) && eleContainer.parents(".acceptwidget").length == 1) {
                console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - on est sur null")
                return null
            } else {
                var eleWidget = lstEle.filter(function (o) { return o.hasClass("widget") && o.closest(eleContainer).length > 0 && !o.is(ui.helper) })[0]
                if (typeof eleWidget != 'undefined') {
                    //on est sur un widget
                    console.log(eleWidget.attr("class"))
                    if (eleWidget.closest(".dxwidgetcolonne").length >= 1) {
                        //on est sur un widget dans une colonne
                        if (ui.helper.attr("typewidget") == "dxwidgetcolonne") {
                            //on glisse une colonne sur une colonne
                            //on retourne la colonne
                            console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - sur une colonne dxwidgetcolonne")
                            return $(eleWidget.closest(".dxwidgetcolonne")[0])
                        } else {
                            //on va gérer la distance pour permettre de rajouter un widget en-dessus ou en-dessous du widget colonne
                            if (eleWidget.prev().length > 0 && eleWidget.next().length > 0) {
                                //on est sur widget au milieu d'autres dans la colonne
                                //on ne change rien
                                console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - sur une colonne " + eleWidget.attr("class"))
                                return eleWidget
                            } else {
                                var offset = eleWidget.offset();
                                var posYBlock = offset.top //- $Iframe[0].contentWindow.document.documentElement.scrollTop;
                                //console.log(pageY + " / " + (posYBlock + eleWidget.innerHeight() / 4 * 1) + " / " + (posYBlock + eleWidget.innerHeight() / 4 * 3))
                                if (eleWidget.prev().length == 0 && yIframeScroll < posYBlock + eleWidget.innerHeight() / 4 * 1) {
                                    //on est dans le 1er Quart
                                    eleWidget = $(eleWidget.closest(".dxwidgetcolonne")[0])
                                    if (eleWidget.prev().length > 0) {
                                        eleWidget = $(eleWidget.prev()[0])
                                    } else {
                                        eleWidget = Me.$TableMessage
                                    }
                                    console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - sur une colonne 1er quart " + eleWidget.attr("class"))
                                    //console.log("1ER QUART")
                                } else if (eleWidget.next().length == 0 && yIframeScroll > posYBlock + eleWidget.innerHeight() / 4 * 3) {
                                    //on est dans le 4ème Quart
                                    eleWidget = $(eleWidget.closest(".dxwidgetcolonne")[0])
                                    console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - sur une colonne 4ème quart " + eleWidget.attr("class"))
                                    //console.log("4EME QUART")
                                } else {
                                    //on est au milieu
                                    //on ne change rien
                                    //console.log("MILIEU")
                                    if (yIframeScroll > posYBlock + eleWidget.innerHeight() / 2) {
                                        //2ème moitié
                                        //on ne change rien
                                        //console.log("2eme moitié")
                                        console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - sur une colonne 2ème moitié " + eleWidget.attr("class"))
                                    } else {
                                        //1ère moitié
                                        //console.log("1ère moitié")
                                        if (eleWidget.prev().length == 0) {
                                            //on a pas de bloc précédent
                                            eleWidget = $(eleWidget.closest(".acceptwidget")[0])
                                        } else {
                                            eleWidget = $(eleWidget.prev()[0])
                                        }
                                        console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - sur une colonne 1ère moitié " + eleWidget.attr("class"))
                                    }
                                }
                                return eleWidget
                            }
                        }
                    } else {
                        //on est sur un widget directement dans le message
                        //on garde le même widget
                        var offset = eleWidget.offset();
                        var posYBlock = offset.top //- $Iframe[0].contentWindow.document.documentElement.scrollTop;
                        if (yIframeScroll > posYBlock + eleWidget.innerHeight() / 2) {
                            //2ème moitié
                        } else {
                            //1ère moitié
                            if (eleWidget.prev().length == 0) {
                                //on a pas de bloc précédent
                                eleWidget = Me.$TableMessage
                            } else {
                                //debugger;
                                eleWidget = $(eleWidget.prev()[0])
                            }
                        }
                        console.log(xIframe + "/" + yIframe + "/" + yIframeScroll + " - widget direct message " + eleWidget.attr("class"))
                        return eleWidget
                    }
                } else {
                    console.log("on est sur un container")
                    //on est sur un container
                    if (!ele.hasClass("acceptwidget") || (ele.hasClass("acceptwidget") && eleContainer.parents(".acceptwidget").length <= 1)) {
                        //l'élément n'est pas un  container OU l'élément est un container et on ne draggue pas dans un container enfant
                        if (eleContainer.find(".widget").length > 0) {
                            //on a des blocks //on retourne le dernier qui se trouve dans le container
                            var lstBlock = []
                            eleContainer.find(".widget").each(function (idx, ele) {
                                if (!$(ele).hasClass("ui-draggable-dragging")) {
                                    if (eleContainer.closest(".acceptwidget").length > 0) {
                                        //on est dans un container de container
                                        var eleSouContainer = eleContainer.closest(".acceptwidget")
                                        if ($(ele).closest(eleSouContainer).length > 0) lstBlock.push($(ele))
                                    } else {
                                        if ($(ele).closest(eleContainer).length > 0) lstBlock.push($(ele))
                                    }
                                }
                            })
                            if (lstBlock.length > 0) {
                                return lstBlock[lstBlock.length - 1]
                            } else {
                                //console.log(eleContainer[0])
                                return eleContainer
                            }
                        } else {
                            //on a pas de blocks
                            return eleContainer
                        }
                    } else {
                        return null
                    }
                }
            }
        }
    }

    this.mGetHtml = function () {
        $DivBody.find(".selected").addClass("oldselected")
        $DivBody.find(".selected").removeClass("selected")
        $DivBody.find(".dxwidgetvide").remove()
        Me.mUpdateStyle()
        mRemoveLigneInsert()
        var $DivGenHtml = $(bodyIframe.find(".divbodymessage")[0].outerHTML)
        $DivGenHtml.find("#cssbaseV1").remove()
        $DivGenHtml.find("#csslocal").remove()
        $DivGenHtml.find("#cssconcepteur").remove()
        $DivGenHtml.find(".ui-draggable").removeClass("ui-draggable")
        $DivGenHtml.find(".ui-draggable-handle").removeClass("ui-draggable-handle")
        $DivGenHtml.find(".ui-draggable-dragging").remove()
        $DivGenHtml.find(".tablepage").attr("cssbaseV1", JSON.stringify(cssBaseV1))
        $DivGenHtml.find(".eledevexpress").empty() //on enleve les ctrl devexpress (formulaire), il seront reconstruit a l'exe

        // styles généraux des liens (guide 'a') recopiés en inline : Gmail & co ignorent souvent le <style> du <head>
        // on ne complète que les propriétés absentes du style inline du lien (les styles propres au widget restent prioritaires)
        // menu_a et bouton_a ont leur propre guide (classe CSS) : on n'y touche pas
        // le style d'origine est conservé dans data-styleorigine et restauré au rechargement (mRempliHtml)
        var jsonGuideA = Me.mGetJsonCssGuide().a
        $DivGenHtml.find("a").not(".menu_a, .bouton_a").each(function () {
            var ajout = ""
            for (var prop in jsonGuideA) {
                var valCss = jsonGuideA[prop]
                if (valCss == null || String(valCss).trim().length == 0) continue
                if (this.style.getPropertyValue(prop).length > 0) continue //déjà défini sur le lien
                ajout += prop + ":" + valCss + ";"
            }
            if (ajout.length == 0) return
            var styleOrigine = $(this).attr("style") || ""
            $(this).attr("data-styleorigine", styleOrigine)
            if (styleOrigine.length > 0 && styleOrigine.trim().slice(-1) != ";") styleOrigine += ";"
            $(this).attr("style", styleOrigine + ajout)
        })

        var html = '' +
            '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//FR">' +
            '<html lang="fr" style="width:100%;height:100%;background-color:' + Me.mJsonCssGuideProperty("bodypage", "background-color") + '" assistant2="1" xmlns="http://www.w3.org/1999/xhtml">' +
            '<head>' +
            '<meta http-equiv="Content-Type" content="text/html; charset=utf-8">' +
            '<meta name="viewport" content="width=device-width, initial-scale=1.0" />' +
            '<meta name="format-detection" content="telephone=no, date=no, address=no, email=no">' +
            '<meta name="x-apple-disable-message-reformatting" />' +
            '<meta name="description" content="">' +
            '<meta name="author" content="Popsoft">' +
            '<style id="cssbaseV1">' +
            cssBaseV1 + '' +
            '</style>' +
            '<style id="csslocal">' +
            Me.mGetCssLocal() + '' +
            '</style>' +
            '</head>' +
            '<body marginheight="0" marginwidth="0" leftmargin="0" topmargin="0" style="-moz-text-size-adjust: none !important; padding: 0px !important; -webkit-text-size-adjust: none !important; margin: 0px !important; -ms-text-size-adjust: none !important; white-space: wrap;">' +
            $DivGenHtml[0].outerHTML +
            "</body>" +
            "</html>"
        $DivBody.find(".oldselected").addClass("selected")
        $DivBody.find(".oldselected").removeClass("oldselected")
        Me.mUpdateStyle()
        return html
    }

    this.mGetWidthPage = function () { return parseInt(Me.$TableMessage.css("max-width").replace("px", "")) }

    var accentColorSelected = theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.5)")
    var accentColorSelectedHover = theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",1)")
    var cssConcepteur = '.tablemessage { min-height:50px; }' +
        '.tablepage { min-height:50px; }' +
        //".tdcol .widgetheightauto { display:inline-block; }" +
        //".widgetheightauto { min-height:30px; }" +
        "tr.widget.selected>td {" +
        "-webkit-box-shadow: inset 0 0 10px 10px " + accentColorSelected + ",0 0 5px 5px " + accentColorSelected + ";" +
        "-moz-box-shadow: inset 0 0 10px 10px " + accentColorSelected + ",0 0 5px 5px " + accentColorSelected + ";" +
        "box-shadow: inset 0 0 10px 10px " + accentColorSelected + ",0 0 5px 5px " + accentColorSelected + ";" +
        "}" +
        "tr.widget.selected>td:hover {" +
        "-webkit-box-shadow: 0 0 10px 10px #787878,inset 0 0 10px 10px " + accentColorSelectedHover + ";" +
        "-moz-box-shadow: 0 0 10px 10px #787878,inset 0 0 10px 10px " + accentColorSelectedHover + ";" +
        "box-shadow: 0 0 10px 10px #787878,inset 0 0 10px 10px " + accentColorSelectedHover + ";" +
        "}" +
        "tr.widget>td:hover {" +
        "-webkit-box-shadow: 0 0 10px 10px #787878;" +
        "-moz-box-shadow: 0 0 10px 10px #787878;" +
        "box-shadow: 0 0 10px 10px #787878;" +
        "}" +
        ".dxwidgetsignature .bodywidget:empty:before { content: 'Signature'; opacity:0.2; font-weight:bold; height:30px; display:inline-block; padding-top:8px; }" +
        ".dxwidgettexte .contenuwidget:empty:before { content: 'Texte'; opacity:0.2; font-weight:bold; height:30px; display:inline-block; padding-top:8px; }" +
        ".dxwidgettitre .bodywidget h1:empty:before { content: 'Titre1'; opacity:0.2; font-weight:bold; }" +
        ".dxwidgettitre .bodywidget h2:empty:before { content: 'Titre2'; opacity:0.2; font-weight:bold; }" +
        ".dxwidgettitre .bodywidget h3:empty:before { content: 'Titre3'; opacity:0.2; font-weight:bold; }" +
        ".dxwidgettitre .bodywidget h4:empty:before { content: 'Titre4'; opacity:0.2; font-weight:bold; }" +
        ".dxwidgetbouton .txtsaisie:empty:before { content: 'Texte bouton'; opacity:0.2; font-weight:bold; }" +
        ".dxwidgetcode .contenuwidget:empty:before { content: 'Code html'; opacity:0.2; font-weight:bold; }" +
        ".texture_drag_construct_email {" +
        "background-image: repeating-linear-gradient(45deg, transparent, transparent 32px, rgba(0, 0, 0, 0.17) 32px, rgba(0, 0, 0, 0.17) 64px);" +
        "background-color: rgba(255, 255, 255, 0);" +
        "}"

    var cssBaseV1 = 'body.divbodymessage { Margin: 0; padding: 0; min-width: 100%; }' +
        'table {border-spacing: 0;}' +
        'td {padding: 0;}' +
        'img {border: 0;}' +
        'a[x-apple-data-detectors] {color: inherit !important;text-decoration: none !important;font-size: inherit !important;font-family: inherit !important;font-weight: inherit !important;line-height: inherit !important;}' +
        '.tablepage * {box-sizing: border-box;}' +
        '@media only screen and (min-width: 0px) and (max-width: 500px) {.tdcol {display: inline-block;width: 100% !important;max-width: 100% !important;min-width: 100% !important;margin: 0 auto !important;}}' +
        '@media only screen and (min-width: 0px) and (max-width: 500px) {.tdcolreseau {display: inline-block;width: 100% !important;max-width: 100% !important;min-width: 100% !important;margin: 0 auto !important;}}'

    function mGetCssA() {
        var txt = ""
        for (var prop in Me.mGetJsonCssGuide().a) {
            var valCss = Me.mGetJsonCssGuide().a[prop]
            if (valCss == null || String(valCss).trim().length == 0) continue //pas de valeur vide (CSS invalide pour Gmail)
            if (txt.length > 0) txt += ";"
            txt += "" + prop + ":" + Me.mGetJsonCssGuide().a[prop] + ""
        }
        return "a {" + txt + "}"
    }

    this.jsonCssGuideBase = {
        bodypage: {
            "font-size": "14px",
            "color": "black",
            "font-family": "Arial",
            "font-weight": "normal",
            "font-style": "normal",
            "text-decoration": "none",
            "line-height": "",
            "letter-spacing": "",
            "text-align": "left",
            "background-color": "rgb(255,255,255)",
            "padding-top": "0px",
            "padding-right": "0px",
            "padding-bottom": "0px",
            "padding-left": "0px"
        },
        bodymessage: {
            "background-color": "rgb(180,180,180)",
            "padding-top": "0px",
            "padding-right": "0px",
            "padding-bottom": "0px",
            "padding-left": "0px",
            "border-width": "0px",
            "border-style": "solid",
            "border-color": "",
            "max-width": "600px"
        },
        p: {
            "font-size": "",
            "color": "",
            "font-family": "",
            "font-weight": "",
            "font-style": "",
            "text-decoration": "",
            "line-height": "",
            "letter-spacing": ""
        },
        h1: {
            "font-size": "30px",
            "color": "",
            "font-family": "",
            "font-weight": "bold",
            "font-style": "",
            "text-decoration": "",
            "line-height": "150%",
            "letter-spacing": ""
        },
        h2: {
            "font-size": "24px",
            "color": "",
            "font-family": "",
            "font-weight": "bold",
            "font-style": "",
            "text-decoration": "",
            "line-height": "130%",
            "letter-spacing": ""
        },
        h3: {
            "font-size": "20px",
            "color": "",
            "font-family": "",
            "font-weight": "bold",
            "font-style": "",
            "text-decoration": "",
            "line-height": "120%",
            "letter-spacing": ""
        },
        h4: {
            "font-size": "16px",
            "color": "",
            "font-family": "",
            "font-weight": "bold",
            "font-style": "",
            "text-decoration": "",
            "line-height": "110%",
            "letter-spacing": ""
        },
        menu: {
            "font-size": "",
            "color": "",
            "font-family": "",
            "font-weight": "",
            "font-style": "",
            "text-decoration": "",
            "line-height": "",
            "letter-spacing": "",
            "border-width": "2px",
            "border-style": "solid",
            "border-color": "black",
        },
        menu_a: {
            "color": "inherit",
            "font-weight": "inherit",
            "font-style": "inherit",
            "text-decoration": "inherit"
        },
        liendesinscription: {
            "font-size": "",
            "color": "",
            "font-family": "",
            "font-weight": "",
            "font-style": "",
            "text-decoration": "",
            "line-height": "",
            "letter-spacing": ""
        },
        lienouvrirnavigateur: {
            "font-size": "",
            "color": "",
            "font-family": "",
            "font-weight": "",
            "font-style": "",
            "text-decoration": "",
            "line-height": "",
            "letter-spacing": ""
        },
        lienretourtop: {
            "font-size": "",
            "color": "",
            "font-family": "",
            "font-weight": "",
            "font-style": "",
            "text-decoration": "",
            "line-height": "",
            "letter-spacing": ""
        },
        a: {
            "color": "rgba(85, 85, 207, 1)",
            "font-weight": "normal",
            "font-style": "normal",
            "text-decoration": "underline"
        },
        blocwidget: {//margin//text-align
            "padding-top": "0px",
            "padding-right": "0px",
            "padding-bottom": "0px",
            "padding-left": "0px",
            "text-align": "center"
        },
        blocwidgetinner: { //padding//border/background-color
            "padding-top": "0px",
            "padding-right": "0px",
            "padding-bottom": "0px",
            "padding-left": "0px",
            "border-width": "0px",
            "border-style": "none",
            "border-color": "none",
            "border-top-right-radius": "0px",
            "border-top-left-radius": "0px",
            "border-bottom-right-radius": "0px",
            "border-bottom-left-radius": "0px",
            "background-color": ""
        },
        separateur: {
            "border-top-width": "2px",
            "border-top-style": "solid",
            "border-top-color": "black",
            "width": "30%"
        },
        bouton_a: {
            "color": "inherit",
            "font-weight": "inherit",
            "font-style": "inherit",
            "text-decoration": "inherit"
        },
        bouton: {
            "text-align": "center",
            "font-size": "16px",
            "color": "white",
            "font-family": "Arial",
            "font-weight": "normal",
            "font-style": "normal",
            "text-decoration": "none",
            "line-height": "100%",
            "letter-spacing": "0",
            "padding-top": "10px",
            "padding-bottom": "10px",
            "padding-left": "10px",
            "padding-right": "10px",
            "border-width": "4px",
            "border-style": "solid",
            "border-color": "black",
            "border-top-right-radius": "0px",
            "border-top-left-radius": "0px",
            "border-bottom-right-radius": "0px",
            "border-bottom-left-radius": "0px",
            "width": "30%",
            "background-color": "rgba(0,0,0,1)"
        },
        devexpress: {
            "text-align": "center",
            "font-size": "16px",
            "color": "white",
            "font-family": "Arial",
            "font-weight": "normal",
            "font-style": "normal",
            "text-decoration": "none",
            "line-height": "100%",
            "letter-spacing": "0",
            "padding-top": "10px",
            "padding-bottom": "10px",
            "padding-left": "10px",
            "padding-right": "10px",
            "border-width": "0px",
            "border-style": "solid",
            "border-color": "black",
            "border-top-right-radius": "0px",
            "border-top-left-radius": "0px",
            "border-bottom-right-radius": "0px",
            "border-bottom-left-radius": "0px",
            "width": "90%",
            "background-color": "transparent"
        },
        image: {
            "width": "30%",
            "border-top-right-radius": "0px",
            "border-top-left-radius": "0px",
            "border-bottom-right-radius": "0px",
            "border-bottom-left-radius": "0px",
        },
        video: {
            "width": "30%",
            "border-top-right-radius": "0px",
            "border-top-left-radius": "0px",
            "border-bottom-right-radius": "0px",
            "border-bottom-left-radius": "0px",
        }
    }
    this.mGetJsonCssGuide = function () {
        return JSON.parse(Me.$TablePage.attr("jsonCssGuide"))
    }
    this.mJsonCssGuideProperty = function (maitre, prop, value) {
        var json = this.mGetJsonCssGuide()
        if (typeof value != 'undefined') {
            if (prop == null) {
                json[maitre] = value
            } else {
                json[maitre][prop] = value
            }
            Me.$TablePage.attr("jsonCssGuide", JSON.stringify(json))
            Me.isDirty = true
            if (dxUndoRedo) dxUndoRedo.mAddAction(bodyIframe.find(".divbodymessage")[0].outerHTML)
        }
        if (typeof prop == 'undefined') {
            return json[maitre]
        } else {
            return json[maitre][prop]
        }

    }
    function mVerifyJsonCssGuide() {
        var jsonCssGuide = Me.mGetJsonCssGuide()
        for (var prop in Me.jsonCssGuideBase) {
            if (typeof jsonCssGuide[prop] == 'undefined') {
                jsonCssGuide[prop] = Me.jsonCssGuideBase[prop]
            } else {
                for (var propCss in Me.jsonCssGuideBase[prop]) {
                    if (typeof jsonCssGuide[prop][propCss] == 'undefined') {
                        jsonCssGuide[prop][propCss] = Me.jsonCssGuideBase[prop][propCss]
                    }
                }
            }
        }
        Me.$TablePage.attr("jsonCssGuide", JSON.stringify(jsonCssGuide))
    }

    this.mGetCssLocal = function () {
        //on rajoute les styles par défaut
        var cssLocal = ""
        var jsonCssGuide = this.mGetJsonCssGuide()
        for (var propStyle in jsonCssGuide) {
            switch (propStyle) {
                case "a": case "p": case "h1": case "h2": case "h3": case "h4":
                    cssLocal += ".tablepage " + propStyle + "{"
                    break;
                default:
                    cssLocal += ".tablepage ." + propStyle + "{"
                    break;
            }
            for (var propCss in jsonCssGuide[propStyle]) {
                var valCss = jsonCssGuide[propStyle][propCss]
                //on n'écrit pas les valeurs vides ("color:;") : Gmail rejette tout le bloc <style> s'il contient du CSS invalide
                if (valCss == null || String(valCss).trim().length == 0) continue
                cssLocal += propCss + ":" + valCss + ";"
            }
            cssLocal += "}"
        }

        return cssLocal
    }

    this.mUpdateStyle = function (modifDirty) {
        $DivBody.find("#style_a").text(mGetCssA())
        $DivBody.closest("html").css("background-color", Me.mJsonCssGuideProperty("bodypage", "background-color"))
        var jsonGuide = Me.mGetJsonCssGuide()
        for (var prop in jsonGuide.bodypage) {
            Me.$TablePage.css(prop, jsonGuide.bodypage[prop])
        }

        for (var prop in jsonGuide.bodymessage) {
            if (prop == "max-width") {
                Me.$TablePage.find(".tdpage").contents().filter(function () { return this.nodeType == 8; }).each(function (idx, ele) {
                    if (ele.data.contains('class="tablemessagemso')) {
                        $(ele).replaceWith("<!--[if (gte mso 9)|(IE)]><table width='" + jsonGuide.bodymessage[prop].replace("px", "") + "' align='center' style='border-spacing:0;' class='tablemessagemso'><tr><td style='padding:0;'><![endif]-->")
                    }
                })
            }
            Me.$TableMessage.css(prop, jsonGuide.bodymessage[prop])
        }
        Me.$TableMessage.find(".widget").each(function (idx, ele) {
            var widget = new cBuilderEmailWidget({
                bddCtrl: option.bddCtrl,
                dxBuilderEmailPage: Me,
                element: $(ele)
            })
            widget.mUpdateCss()
        })
        Me.$TableMessage.attr("width", jsonGuide.bodymessage["max-width"].replace("px", ""))
        $EleStyleLocal.text(Me.mGetCssLocal())
    }

    this.mGetLstColor = function () {
        var lstColor = []
        $DivBody.find("*").each(function (idx, ele) {
            var color = $(ele).css("color")
            if (color.startsWith("rgba(")) {
                if ((color.endsWith(",0)") || color.endsWith(", 0)"))) { color = null }
                else {
                    var lstCol = color.split("(")[1].split(",")
                    color = "rgb(" + lstCol[0] + "," + lstCol[1] + "," + lstCol[2] + ")"
                }
            }
            if (color != null && !lstColor.contains(color) && color != theme.backgroundcolorAccent) lstColor.push(color)
            var color = $(ele).css("background-color")
            if (color.startsWith("rgba(")) {
                if ((color.endsWith(",0)") || color.endsWith(", 0)"))) { color = null }
                else {
                    var lstCol = color.split("(")[1].split(",")
                    color = "rgb(" + lstCol[0] + "," + lstCol[1] + "," + lstCol[2] + ")"
                }
            }
            if (color != null && !lstColor.contains(color) && color != theme.backgroundcolorAccent) lstColor.push(color)
            var color = $(ele).css("border-color")
            if (color.startsWith("rgba(")) {
                if ((color.endsWith(",0)") || color.endsWith(", 0)"))) { color = null }
                else {
                    var lstCol = color.split("(")[1].split(",")
                    color = "rgb(" + lstCol[0] + "," + lstCol[1] + "," + lstCol[2] + ")"
                }
            }
            if (color != null && !lstColor.contains(color) && color != theme.backgroundcolorAccent) lstColor.push(color)
        })
        return lstColor
    }

    this.demandeTag = function () { option.onDemandeTag() }

    this.element = function () { return container }

    function mConstruireTemplate() {

        var eleMove = (new cBuilderEmailWidget({
            bddCtrl: option.bddCtrl,
            dxBuilderEmailPage: Me,
            typeWidget: "dxwidgettexte"
        })).option("element")
        eleMove.appendTo(Me.$TableMessage)
        $("<p>Victor Hugo, parfois surnommé l'<a href='http://www.mascaron.eu' target='_blanks'>Homme océan ou, de manière posthume</a>, l'Homme siècle, est un poète, dramaturge siècle.</p>").appendTo(eleMove.find(".bodywidget"))

        var widgetCol2 = (new cBuilderEmailWidget({
            bddCtrl: option.bddCtrl,
            dxBuilderEmailPage: Me,
            nbCol: 2,
            typeWidget: "dxwidgetcolonne",
        }))
        widgetCol2.option("element").appendTo(Me.$TableMessage)

        Me.mUpdateStyle()

    }

    mConstruit();
}